var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnClickerLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 90,
    viewBox: "0 0 120 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3974_5415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 1H45C20.6995 1 1 20.6995 1 45C1 69.3005 20.6995 89 45 89H75C99.3005 89 119 69.3005 119 45C119 20.6995 99.3005 1 75 1Z",
    fill: "url(#paint0_linear_3974_5415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 1H45C20.6995 1 1 20.6995 1 45C1 69.3005 20.6995 89 45 89H75C99.3005 89 119 69.3005 119 45C119 20.6995 99.3005 1 75 1Z",
    stroke: "url(#paint1_linear_3974_5415)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3974_5415",
    x1: 61.7278,
    y1: 90,
    x2: 61.7277,
    y2: -3.59035e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3974_5415",
    x1: 64.6722,
    y1: 89,
    x2: 64.6722,
    y2: 0.188206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3974_5415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnClickerLight);
export default __webpack_public_path__ + "static/media/btn_clicker_light.2d98969e4496241443ede0b5c30ff23c.svg";
export { ForwardRef as ReactComponent };